<mat-card>
  <mat-card-header>
    <mat-card-title>{{'title.customer_detail' | translate}} {{customer.name}}</mat-card-title>
  </mat-card-header>
  <mat-tab-group [selectedIndex]="currentTab" (selectedIndexChange)="isInforTab = $event">
    <mat-tab [label]="'title.customer_detail_upper' | translate">
    </mat-tab>
    <mat-tab [label]="'title.config_group_customer' | translate">
      <app-customer-configuration [customerId]="customer.id" [isView]="isView"></app-customer-configuration>
    </mat-tab>
  </mat-tab-group>

  <mat-card-content [ngClass]="isInforTab === 0 ? '' : 'd-none'">
    <mat-accordion #accordion="matAccordion" [multi]="true" expanded="true">
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.customer_info' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div  class="row" #focus tabindex="-1" *ngIf="!isNotAttestedUser">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.username' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.adminUser}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.infomation_email' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.primaryEmail}}</div>
        </div>
        <div  class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'search_form.custommer_name' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.name}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.customer_type' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{getEnterpriseTypeOptions(customerType)}}</div>
        </div>
        <div  class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'headertable.customer_code' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.customerCode}}</div>
          <ng-container *ngIf="isShowInfor && (customer.customerType == personalId || customer.customerType == null)">
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.birthday' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.birthdayDisplay}}</div>
          </ng-container>
        </div>
        <div class=" row" *ngIf="isShowInfor && (customer.customerType == personalId || customer.customerType == null)">
<!--          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.birthday' | translate}}</label>-->
<!--          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.birthdayDisplay}}</div>-->
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.sex' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 d-flex" [ngSwitch]="customer.sex">
            <span *ngSwitchCase="false" class="col-form-label font-weight-bold">{{'form.female' | translate}}</span>
            <span *ngSwitchCase="true" class="col-form-label font-weight-bold">{{'form.male' | translate}}</span>
          </div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.type_certification' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.customerType != personalId ?
            getEnterpriseTypeOptions(certificate) : getEnterpriseTypeOptions(representativeCertificateName)}}</div>
        </div>
        <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.gpkd' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.certificateNo}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_date' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.issuedDateDisplay}}</div>
        </div>
        <div  class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_by' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.issuedAt}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right"
                 *ngIf="customer.customerType != personalId && customer.customerType != null">{{'form.tax_code' |
            translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold"
               *ngIf="customer.customerType != personalId && customer.customerType != null">{{customer.taxCode}}</div>
        </div>
<!--        <div  class="row">-->
<!--         -->
<!--        </div>-->
      </mat-expansion-panel>
      <mat-expansion-panel expanded="true" *ngIf="customer.customerType != personalId && customer.customerType != null">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.representative_info' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class=" row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.full_name' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.representative}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.position' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.position}}</div>
        </div>
        <div class=" row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.birthday' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.birthdayDisplay}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.sex' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 d-flex" [ngSwitch]="customer.sex">
            <span class="col-form-label font-weight-bold" *ngSwitchCase="0">{{'form.female' | translate}}</span>
            <span class="col-form-label font-weight-bold" *ngSwitchCase="1">{{'form.male' | translate}}</span>
          </div>
        </div>
        <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.type_certification' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">
            {{getEnterpriseTypeOptions(representativeCertificateName)}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.gpkd' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.representativeCertificateNo}}</div>
        </div>
        <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_date' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.representativeIssuedDateDisplay}}
          </div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_by' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.representativeIssuedAt}}</div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel  expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.address' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class=" row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.city' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{ addresses.cityName }}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="!customer.isNewAddress">{{'form.district' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="!customer.isNewAddress">{{ addresses.districtName }}</div>
        
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.ward' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{ addresses.wardName }}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.address' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.address}}</div>
        
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.receive_email' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.email}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'search_form.phone' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.phone}}</div>
        </div>
        <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.fax' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.fax}}</div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel  expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.pay_info' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.accnumber' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.accountNumber}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.accountName' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.accountName}}</div>
        </div>
        <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.bank' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.bankName}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'search_form.branch' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{customer.bankBranch}}</div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel  expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.attach' | translate}}
            <mat-label *ngIf="!customer.attachments?.length">&nbsp;{{'title.no_attachment' | translate}}</mat-label>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-upload-multi-file [isViewDetail]="true" [isCustomer]="true" [arrAttachments]="this.customer.attachments">
        </app-upload-multi-file>
      </mat-expansion-panel>

       <!-- Hồ sơ khách hàng -->
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ customer.customerType == 10000 ? ('title.customer_information' | translate) : ('title.enterprise_information' | translate)}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-kyc-customer-infor [type]="customer.customerType == 10000 ? 'personal' : 'enterprise'" [listImageResponse]="customer.attachmentImages" [readonly]="readonly"></app-kyc-customer-infor>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>

  <mat-card-actions class="text-center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onBackClick('/home-enterprise/customers')" appTrackEvent="w.btn.danh_sach_kh.xem_chi_tiet.quay_lai"
      type="button">
      <mat-icon class="mr-0">arrow_back</mat-icon>
      {{'form.back' | translate}}
    </button>
    <button *ngIf="(customer.id && userType !== -1 && userType !== 2) || checkDisplayBtnUpdateCustomer(customer)" appTrackEvent="w.btn.danh_sach_kh.xem_chi_tiet.cap_nhat"
      [disabled]="!customer.hasPermission || commonService.getIsLockedEnterprise()" mat-raised-button type="button"
      (click)="onUpdateClick('/home-enterprise/update-customer/', customer.id)" color="primary">
      <mat-icon class="mr-0">edit</mat-icon>
      {{'button.update' | translate}}
    </button>
  </mat-card-actions>
</mat-card>
